import { useParams } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import {
  doc,
  getDoc,
  getDocs,
  collection,
  setDoc,
  increment,
  serverTimestamp,
} from "firebase/firestore";
import { db } from "./firebase";
import {
  trackAnalyticsEvent,
  trackAnalyticsTabOpen,
} from "./analytics/siteAnalytics";
import './ProductPage.css';
import { FaHome } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

import { Canvas, useFrame, useThree } from "@react-three/fiber";
import { useGLTF, Center, OrbitControls } from "@react-three/drei";
import * as THREE from "three";

// PRODUCT CONFIGURATOR
import SelfocLensConfigurator from './components/configurators/SelfocLensConfigurator';


export function superscriptRegistered(text) {
  if (!text) return '';
  return text.replace(/®/g, '<sup style="font-size:0.65em; vertical-align: super;">®</sup>');
}

const hotspotConfig = {
  'PEACOC® Enhanced View and Access (EVA) High Density Patch Panel': [
    { x: 30, y: 60, text: 'Patch and Splice cassettes' },
    { x: 140, y: 90, text: 'Modular front ports' },
    // Add more here...
  ]
};

const getLocalDateKey = (date = new Date()) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

const getProductViewDocId = (productSlug, dateKey) => `${productSlug}_${dateKey}`;

const formatSeconds = (seconds = 0) => {
  const mins = Math.floor(seconds / 60);
  const secs = Math.round(seconds % 60);

  if (mins <= 0) return `${secs}s`;
  return `${mins}m ${secs}s`;
};

function Model({ modelType }) {
  const modelConfig = {
    eva: {
      path: "/3DProducts/EVA.glb",
      scale: 1,
    },

    "4PortMMT": {
      path: "/3DProducts/4PortMMT.glb",
      scale: 0.25,
    },

    "4PortMMTOpen": {
      path: "/3DProducts/4PortMMTOpen.glb",
      scale: 0.25,
    },
  };

  const config = modelConfig[modelType];

  const { scene } = useGLTF(config.path);

  return (
    <Center>
      <primitive
        object={scene}
        scale={config.scale}
        rotation={[-Math.PI / 2, Math.PI, 0]}
      />
    </Center>
  );
}


function CameraController({ targetPosition }) {
  const { camera } = useThree();
  const isMoving = useRef(false);

  useEffect(() => {
    isMoving.current = true;
  }, [targetPosition]);

  useFrame(() => {
    if (!isMoving.current) return;

    camera.position.lerp(targetPosition, 0.05);
    camera.lookAt(0, 0, 0);

    const distance = camera.position.distanceTo(targetPosition);

    if (distance < 0.1) {
      isMoving.current = false;
    }
  });

  return null;
}




const solutions = [
  // {
  //   name: "AI",
  //   slug: "ai",
  //   solutionImage: "/images/solutions/ai.jpg",
  //   solutionHeading: "A New Generation of Connectivity for AI",
  //   solutionDescription: "Every leap forward, every scalable solution, every AI-driven revolution relies on the power of fiber optics at its core"
  // },
    {
    name: "AI",
    slug: "ai",
    solutionImage: "/images/solutions/ai.jpg",
    solutionHeading: "Your home for AI data center fiber infastructure",
    solutionDescription: "Every leap forward, every scalable solution, every AI-driven innovation relies on the power of fiber optics."
  },
  {
    name: "Data Center",
    slug: "datacenter",
    solutionImage: "/images/solutions/datacenter.jpg",
    solutionHeading: "Designing and developing data centers for what is not yet imagined.",
    solutionDescription: "With the potential to be the transformative technology of our generation, we’re creating DCI solutions to ensure AIs potential and impact are limitless"
  },
  {
    name: "Central Office & Headend",
    slug: "central-office",
    solutionImage: "/images/solutions/centralOffice.jpg",
    solutionHeading: "Next-generation fiber connectivity solution",
    solutionDescription: "Where modern networks converge and tomorrow's service delivery begins"
  },
  {
    name: "Outside Plant",
    slug: "outside-plant",
    solutionImage: "/images/solutions/outsidePlant.png",
    solutionHeading: "CONNECTED COMMUNITIES RELY ON OUTSIDE PLANT SOLUTIONS",
    solutionDescription: "Fiber optics are connecting communities and transforming the way we live. If you are ready to deliver more and do more for your community, we can help."
  },
  {
    name: "FTTx & MDU",
    slug: "fttx",
    solutionImage: "/images/solutions/ftth.jpg",
    solutionHeading: "Fiber First. Everywhere It Counts",
    solutionDescription: "Empowering fiber access for homes, buildings, and communities"
  },
  {
    name: "Rural Broadband",
    slug: "rural-broadband",
    solutionImage: "/images/solutions/ruralBroadband.jpeg",
    solutionHeading: "A Smarter Path to Rural Broadband",
    solutionDescription: "Transforming connectivity and communities with fiber-first solutions"
  },
  {
    name: "Wireless",
    slug: "wireless",
    solutionImage: "/images/solutions/wireless.jpg",
    solutionHeading: "A New Era of Wireless Connectivity",
    solutionDescription: "Fiber optics powering the future of wireless networks"
  },
  {
    name: "Enterprise",
    slug: "enterprise",
    solutionImage: "/images/solutions/enterprise.jpeg",
    solutionHeading: "Unlock Your Enterprise's Potential with Next-Gen Fiber Solutions",
    solutionDescription: "Seamless Connectivity for a Fast-Paced Digital World"
  },
  {
    name: "Medical Imaging",
    slug: "medical-imaging",
    solutionImage: "/images/solutions/medicalImaging.jpeg",
    solutionHeading: "Sharper Medical Images Begin with Superior Optics",
    solutionDescription: "Where innovation meets precision"
  },
  {
    name: "Neuroscience",
    slug: "neuroscience",
    solutionImage: "/images/solutions/neuroscience.jpeg",
    solutionHeading: "Superior Optics for Revolutionary Neuroscience",
    solutionDescription: "Where scientific innovation meets unparalleled clarity, setting the stage for transformative discoveries"
  },{
    name: "Specialty Optics",
    slug: "specialty-optics",
    solutionImage: "/images/solutions/specialtyOptics.jpeg",
    solutionHeading: "See Further, Discover Faster: Specialty Optics Engineered for Innovation",
    solutionDescription: "Delivering high-performance and driving breakthroughs"
  },
];


function ProductPage() {
    const navigate = useNavigate(); // Make sure this is inside your component

  const { slug } = useParams();
  const productSlug = slug;
  const [product, setProduct] = useState(null);
  const [activeProductTab, setActiveProductTab] = useState('features');
    const [isLoaded, setIsLoaded] = useState(false); // New state to track if data fetch is complete

    useEffect(() => {
  if (!productSlug || !product) return;

  const sessionKey = `product-view-counted-${productSlug}`;

  if (sessionStorage.getItem(sessionKey)) return;

  const trackProductView = async () => {
    try {
      const dateKey = getLocalDateKey();
      const viewDocId = `${productSlug}_${dateKey}`;

      await setDoc(
        doc(db, "productViews", viewDocId),
        {
          productSlug,
          productName: product.product || productSlug,
          productFamily: product.productFamily || "",
          subFamily: product.subFamily || "",
          date: dateKey,
          count: increment(1),
          updatedAt: serverTimestamp(),
          createdAt: serverTimestamp(),
        },
        { merge: true }
      );

      sessionStorage.setItem(sessionKey, "true");
    } catch (err) {
      console.error("Error tracking product view:", err);
    }
  };

  trackProductView();
}, [productSlug, product]);

useEffect(() => {
  if (!productSlug || !product) return;

  trackAnalyticsEvent("product_view", {
    productSlug,
    productName: product.product || productSlug,
    productFamily: product.productFamily || "",
    subFamily: product.subFamily || "",
  });
}, [productSlug, product]);

  const [expandedSections, setExpandedSections] = useState({
  features: true,  // default open
  category1: false,
  category2: false,
  category3: false,
  category4: false,
  category5: false,
  category6: false,
  category7: false,
  category8: false,
  category9: false,
  category10: false,
  faq: false,
});

const toggleSection = (section) => {
  const isOpening =
    !expandedSections[section];

  setExpandedSections((prev) => ({
    ...prev,
    [section]:
      !prev[section],
  }));

  if (isOpening) {
    trackAnalyticsTabOpen(
      section,
      {
        productSlug,
        productName:
          product?.product ||
          productSlug,
        tabType:
          "product_accordion",
      }
    );
  }
};


  useEffect(() => {
    
    const fetchProduct = async () => {
      setIsLoaded(false);
      const ref = doc(db, "products", productSlug);
      const snapshot = await getDoc(ref);
      if (snapshot.exists()) setProduct(snapshot.data());

      console.log("PRODUCT DATA", snapshot.data());
console.log("category1Heading", product?.category1Heading);
console.log("category1Description", product?.category1Description);

    setIsLoaded(true); 
    };
    fetchProduct();

  }, [productSlug]);

const [frequentlyUsedWith, setFrequentlyUsedWith] = useState([]);
const [relatedProducts, setRelatedProducts] = useState([]);
const [visibleStartIndex, setVisibleStartIndex] = useState(0);
const [visibleStartIndex2, setVisibleStartIndex2] = useState(0);
const [slidesPerView, setSlidesPerView] = useState(3);
const [currentIndex2, setCurrentIndex2] = useState(0);
const [currentIndex3, setCurrentIndex3] = useState(0);
const [slidesPerView3, setSlidesPerView3] = useState(3);

const modelPath = "/3DProducts/EVA.glb";
const [show3D, setShow3D] = useState(false);

const [galleryIndex, setGalleryIndex] = useState(0);
const [gallerySlidesPerView, setGallerySlidesPerView] = useState(3);
const [selectedImage, setSelectedImage] = useState(null);
const [cameraPosition, setCameraPosition] = useState(
  new THREE.Vector3(0, 35, 95)
);


const productImages =
  product
    ? [
        product.image,
        product.image2,
        product.image3,
        product.image4,
        product.image5,
        product.image6,
        product.image7,
        product.image8,
        product.image9,
      ].filter(Boolean)
    : [];


const [imgStartIndex, setImgStartIndex] = useState(0);

const getVisibleImages = () => {
  const total = productImages.length;
  return [
    productImages[imgStartIndex % total],
    productImages[(imgStartIndex + 1) % total],
    productImages[(imgStartIndex + 2) % total]
  ];
};

useEffect(() => {
  const updateSlidesPerView = () => {
  if (window.innerWidth <= 768) {
    setSlidesPerView(1);
    setSlidesPerView3(1);
  } else if (window.innerWidth <= 1024) {
    setSlidesPerView(2);
    setSlidesPerView3(2);
  } else if (window.innerWidth >= 1600) {
    setSlidesPerView(4);
    setSlidesPerView3(4);
  } else {
    setSlidesPerView(3);
    setSlidesPerView3(3);
  }
};

  updateSlidesPerView();
  window.addEventListener("resize", updateSlidesPerView);

  return () => window.removeEventListener("resize", updateSlidesPerView);
}, []);

useEffect(() => {
  const updateGallerySlidesPerView = () => {
    if (window.innerWidth <= 768) {
      setGallerySlidesPerView(1);
    } else if (window.innerWidth <= 1100) {
      setGallerySlidesPerView(2);
    } else {
      setGallerySlidesPerView(3);
    }
  };

  updateGallerySlidesPerView();
  window.addEventListener("resize", updateGallerySlidesPerView);
  return () => window.removeEventListener("resize", updateGallerySlidesPerView);
}, []);

const categorySections = [1, 2, 3, 4, 5]
  .map((num) => {
    const heading = product?.[`category${num}Heading`];
    const description = product?.[`category${num}Description`];

    if (!heading && !description) return null;

    return {
      key: `category${num}`,
      heading,
      description,
    };
  })
  .filter(Boolean);


useEffect(() => {
  if (!product || !Array.isArray(product.frequentlyUsedWith) || product.frequentlyUsedWith.length === 0) return;

  const fetchFrequentlyUsedWith = async () => {
    const snap = await getDocs(collection(db, 'products'));
    const allProducts = snap.docs.map(doc => ({ id: doc.id, ...doc.data() }));

    const matched = allProducts.filter(p =>
      product.frequentlyUsedWith.includes(p.product)
    );

    setFrequentlyUsedWith(matched);
  };

  fetchFrequentlyUsedWith();
}, [product]);

const productTimeRef = useRef({
  activeSeconds: 0,
  lastInteractionAt: Date.now(),
  lastSavedActiveSeconds: 0,
});

const saveProductActiveTime = async () => {
  if (!productSlug || !product) return;

  const totalActive = productTimeRef.current.activeSeconds;
  const unsavedSeconds = totalActive - productTimeRef.current.lastSavedActiveSeconds;

  if (unsavedSeconds < 3) return;

  productTimeRef.current.lastSavedActiveSeconds = totalActive;

  try {
    const dateKey = getLocalDateKey();
    const viewDocId = getProductViewDocId(productSlug, dateKey);

    await setDoc(
      doc(db, "productViews", viewDocId),
      {
        productSlug,
        productName: product.product || productSlug,
        productFamily: product.productFamily || "",
        subFamily: product.subFamily || "",
        date: dateKey,
        timeOnPageSeconds: increment(unsavedSeconds),
        updatedAt: serverTimestamp(),
      },
      { merge: true }
    );

  } catch (err) {
    console.error("Error tracking product active time:", err);
  }
};

useEffect(() => {
  if (!productSlug || !product) return;

  productTimeRef.current = {
    activeSeconds: 0,
    lastInteractionAt: Date.now(),
    lastSavedActiveSeconds: 0,
  };

  const markInteraction = () => {
    productTimeRef.current.lastInteractionAt = Date.now();
  };

  const timer = setInterval(() => {
    const isVisible = document.visibilityState === "visible";
    const isFocused = document.hasFocus();
    const recentlyActive = Date.now() - productTimeRef.current.lastInteractionAt <= 60000;

    if (isVisible && isFocused && recentlyActive) {
      productTimeRef.current.activeSeconds += 1;
    }
  }, 1000);

  const saveTimer = setInterval(saveProductActiveTime, 15000);

  const handleVisibility = () => {
    if (document.visibilityState === "hidden") {
      saveProductActiveTime();
    } else {
      markInteraction();
    }
  };

  window.addEventListener("pointerdown", markInteraction, { passive: true });
  window.addEventListener("mousemove", markInteraction, { passive: true });
  window.addEventListener("touchstart", markInteraction, { passive: true });
  window.addEventListener("keydown", markInteraction);
  window.addEventListener("scroll", markInteraction, { passive: true });
  window.addEventListener("pagehide", saveProductActiveTime);
  document.addEventListener("visibilitychange", handleVisibility);

  return () => {
    clearInterval(timer);
    clearInterval(saveTimer);
    saveProductActiveTime();

    window.removeEventListener("pointerdown", markInteraction);
    window.removeEventListener("mousemove", markInteraction);
    window.removeEventListener("touchstart", markInteraction);
    window.removeEventListener("keydown", markInteraction);
    window.removeEventListener("scroll", markInteraction);
    window.removeEventListener("pagehide", saveProductActiveTime);
    document.removeEventListener("visibilitychange", handleVisibility);
  };
}, [productSlug, product]);

useEffect(() => {
  if (!product || !Array.isArray(product.relatedProducts) || product.relatedProducts.length === 0) return;

  const fetchRelatedProducts = async () => {
    const snap = await getDocs(collection(db, 'products'));
    const allProducts = snap.docs.map(doc => ({ id: doc.id, ...doc.data() }));

    const matched = allProducts.filter(p =>
      product.relatedProducts.includes(p.product)
    );

    setRelatedProducts(matched);
  };

  fetchRelatedProducts();
}, [product]);

const visibleProducts = frequentlyUsedWith.slice(visibleStartIndex, visibleStartIndex + 3);
const visibleProducts2 = relatedProducts.slice(visibleStartIndex2, visibleStartIndex2 + 3);

const galleryMaxIndex = Math.max(productImages.length - gallerySlidesPerView, 0);

const nextImage = () => {
  setGalleryIndex((prev) => Math.min(prev + 1, galleryMaxIndex));
};

const prevImage = () => {
  setGalleryIndex((prev) => Math.max(prev - 1, 0));
};

useEffect(() => {
  if (galleryIndex > galleryMaxIndex) {
    setGalleryIndex(galleryMaxIndex);
  }
}, [galleryIndex, galleryMaxIndex]);

useEffect(() => {
  const handleKeyDown = (e) => {
    if (e.key === "Escape") setSelectedImage(null);
  };

  if (selectedImage) {
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", handleKeyDown);
  } else {
    document.body.style.overflow = "";
  }

  return () => {
    document.body.style.overflow = "";
    window.removeEventListener("keydown", handleKeyDown);
  };
}, [selectedImage]);

const handleNext2 = () => {
  const maxIndex = Math.max(relatedProducts.length - slidesPerView, 0);

  setCurrentIndex2((prev) =>
    prev >= maxIndex ? 0 : prev + 1
  );
};

const handlePrev2 = () => {
  const maxIndex = Math.max(relatedProducts.length - slidesPerView, 0);

  setCurrentIndex2((prev) =>
    prev <= 0 ? maxIndex : prev - 1
  );
};

const trackProductDownload = async (resourceLabel = "Resource") => {
  if (!productSlug || !product) return;

  try {
    const dateKey = getLocalDateKey();
    const viewDocId = getProductViewDocId(productSlug, dateKey);

    await setDoc(
      doc(db, "productViews", viewDocId),
      {
        productSlug,
        productName: product.product || productSlug,
        productFamily: product.productFamily || "",
        subFamily: product.subFamily || "",
        date: dateKey,
        downloads: increment(1),
        lastDownloadLabel: resourceLabel,
        updatedAt: serverTimestamp(),
      },
      { merge: true }
    );

    await trackAnalyticsEvent("document_download", {
      productSlug,
      productName: product.product || productSlug,
      productFamily: product.productFamily || "",
      resourceLabel,
    });
  } catch (err) {
    console.error("Error tracking product download:", err);
  }
};

useEffect(() => {
  const maxIndex = Math.max(relatedProducts.length - slidesPerView, 0);
  if (currentIndex2 > maxIndex) {
    setCurrentIndex2(maxIndex);
  }
}, [slidesPerView, relatedProducts.length, currentIndex2]);

const handleNext3 = () => {
  const maxIndex = Math.max(frequentlyUsedWith.length - slidesPerView3, 0);

  setCurrentIndex3((prev) =>
    prev >= maxIndex ? 0 : prev + 1
  );
};

const handlePrev3 = () => {
  const maxIndex = Math.max(frequentlyUsedWith.length - slidesPerView, 0);

  setCurrentIndex3((prev) =>
    prev <= 0 ? maxIndex : prev - 1
  );
};

useEffect(() => {
  const maxIndex = Math.max(frequentlyUsedWith.length - slidesPerView3, 0);
  if (currentIndex3 > maxIndex) {
    setCurrentIndex3(maxIndex);
  }
}, [slidesPerView3, frequentlyUsedWith.length, currentIndex2]);

function getYouTubeId(input) {
  if (!input) return null;
  const s = String(input).trim();

  // already an 11-char ID
  if (/^[a-zA-Z0-9_-]{11}$/.test(s)) return s;

  // try common URL shapes
  const m =
    s.match(/youtu\.be\/([^?&#/]+)/) ||
    s.match(/[?&]v=([^&]+)/) ||
    s.match(/youtube\.com\/shorts\/([^?&#/]+)/);
  return m ? m[1] : null;
}

const videoId = getYouTubeId(product?.featuredContentVideo);




    // SLiding logic
    let currentIndex = 0;
    const slide = (dir) => {
    const track = document.getElementById("slider-track");
    if (!track) return;

    const tiles = track.children;
    const maxIndex = tiles.length - 3;

    currentIndex = Math.min(Math.max(currentIndex + dir, 0), maxIndex);
    track.style.transform = `translateX(-${currentIndex * 33.33}%)`;
    };

    useEffect(() => {
    const interval = setInterval(() => slide(1), 5000);
    return () => clearInterval(interval);
    }, []);

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
        
        useEffect(() => {
          const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
          };
          window.addEventListener("resize", handleResize);
          return () => window.removeEventListener("resize", handleResize);
        }, []);

const matchedSolutions = product?.industry
  ? solutions.filter(sol => product.industry.includes(sol.name)).slice(0, 3)
  : [];

        
if(!isLoaded) return (
  <>
  <div
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '95vh',
      background: '#fff',
      width: '100%',
    }}
  >
    <div
      style={{
        width: 56,
        height: 56,
        border: '4px solid rgba(35,176,186,0.2)',
        borderTop: '4px solid #23B0BA',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite',
      }}
    />
    <style>{`
      @keyframes spin {
        to { transform: rotate(360deg); }
      }
    `}</style>
  </div>
  <div className="curved-footer">
        <div className="curved-top-overlay"></div>
        
        <h2>Would you like to hear more?</h2>
        <p>Our experts would love to hear about your systems and how we can help</p>
        <a className="connect-button" href="/support">LET’S CONNECT</a>
        </div>
</>
);

const formatDescription = (text) => {
  if (!text) return null;

  const parts = text.split("•");

  // first part is normal paragraph text
  const intro = parts[0].trim();

  const bullets = [];
  const paragraphs = [];

  parts.slice(1).forEach((item) => {
    const cleaned = item.trim();

    if (cleaned.includes(";")) {
      const [bulletText, afterText] = cleaned.split(";");
      bullets.push(bulletText.trim());
      paragraphs.push(afterText.trim());
    } else {
      bullets.push(cleaned);
    }
  });

  return (
    <>
      {intro && <p>{intro}</p>}

      {bullets.length > 0 && (
        <ul>
          {bullets.map((b, i) => (
            <li key={i}>{b}</li>
          ))}
        </ul>
      )}

      {paragraphs.map((p, i) => (
        <p key={`p-${i}`}>{p}</p>
      ))}
    </>
  );
};

const formatCategoryDescription = (text) => {
  if (!text) return null;

  const input = String(text).trim();

  const renderInlineFormatting = (str) => {
    const pieces = [];
    const regex = /<b>(.*?)(?:<\/b>|<b>)/gi;

    let lastIndex = 0;
    let match;
    let key = 0;

    while ((match = regex.exec(str)) !== null) {
      if (match.index > lastIndex) {
        pieces.push(str.slice(lastIndex, match.index));
      }

      pieces.push(
        <strong
          key={`bold-${key++}`}
          style={{ fontWeight: 700, textDecoration: "underline" }}
        >
          {match[1]}
        </strong>
      );

      lastIndex = regex.lastIndex;
    }

    if (lastIndex < str.length) {
      pieces.push(str.slice(lastIndex));
    }

    return pieces;
  };

  const hasHtmlTags = /<\/?(div|table|thead|tbody|tr|th|td|p|ol|ul|li|h1|h2|h3|h4|h5|h6|img|br|sub|sup|strong)\b/i.test(
    input
  );

  // If the string contains real HTML, render it as HTML.
  // If not, keep your semicolon-based paragraph splitting.
  if (hasHtmlTags) {
    const normalizedHtml = input.replace(
      /<b>(.*?)(?:<\/b>|<b>)/gi,
      '<strong style="font-weight:700; text-decoration:underline;">$1</strong>'
    );

    return (
      <div
        style={{
          width: "100%",
          overflowWrap: "break-word",
        }}
        dangerouslySetInnerHTML={{ __html: normalizedHtml }}
      />
    );
  }

  return (
    <>
      {input
        .split(";")
        .map((part) => part.trim())
        .filter(Boolean)
        .map((part, i) => (
          <p key={i} style={{ marginBottom: "1rem" }}>
            {renderInlineFormatting(part)}
          </p>
        ))}
    </>
  );
};

if (isLoaded && !product) {
    // If loading is complete but no product was found, display the 404 message.
    // This correctly handles the product slug route when the product doesn't exist.
    return (
      <>
      <div className="product-page" style={{ height: '70vh', textAlign: 'center', paddingTop: '150px', marginBottom: '-100px', paddingRight: '10vw', paddingLeft: '10vw' }}>
        <img
            src="/images/wireBreak.png"
            alt="Error 404"
            style={{ height: 90, width: 90}}
          />
        <h2 style={{marginBottom: 20}}>404: Signal Loss</h2>
        <p>
          We've hit a discontinuity! The requested wavelength could not be found at this address. It seems the fiber is broken or the termination point is incorrect. While our engineers are looking into the link failure, you can return to the main network.
        </p>
        <button 
          onClick={() => navigate('/products')}
          className="cta-button"
        >
          View All Products
        </button>
      </div>

       <div className="curved-footer">
        <div className="curved-top-overlay"></div>
        
        <h2>Would you like to hear more?</h2>
        <p>Our experts would love to hear about your systems and how we can help</p>
        <a className="connect-button" href="/support">LET’S CONNECT</a>
        </div>
</>
    );
  }
  

  return (
    <div className="product-page">
        <div className="curved-header-prod" style={{ background: isMobile ? '#8CC540' : ''}}>
        <h1 dangerouslySetInnerHTML={{ __html: superscriptRegistered(product.product) }} />
        

        </div>

        <div className="breadcrumbs">
        <a href="/" className="breadcrumb-link">
            <FaHome className="breadcrumb-icon" />
        </a>
        <span className="breadcrumb-separator">/</span>

        {/* Clickable productFamily breadcrumb */}
        <span
            className="breadcrumb-link"
            onClick={() => navigate(`/${product.productFamily.toLowerCase().replace(/\s+/g, '-')}`)}
            style={{ cursor: 'pointer' }}
        >
            {product.productFamily}
        </span>

        <span className="breadcrumb-separator">/</span>
        <span className="breadcrumb-text">{product.subFamily}</span>
        <span className="breadcrumb-separator">/</span>
        <strong className="breadcrumb-current" dangerouslySetInnerHTML={{ __html: superscriptRegistered(product.product) }} />
        
        </div>


        <div className="product-section">
            <div className="left-column">
                <div className="image-container">
                <img
                    src={
                    product.image && product.image.trim() !== ""
                        ? product.image
                        : "https://placehold.co/150x150?text=No+Image"
                    }
                    alt={product.product}
                    className="product-image-page"
                />
                </div>

                <div className="resources-box">
                <img src="https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/stockImages%2FexclamationPurple.png?alt=media&token=fb7fc42a-1a8e-4625-a363-bfcd98f651b3" alt="Resources Icon" className="resources-icon" />
                <div className="resources-text">
                    <h4>Resources</h4>
                    {product.dataSheet && (
                      <a
                        href={product.dataSheet}
                        target="_blank"
                        rel="noreferrer"
                        onClick={() => trackProductDownload("Datasheet")}
                      >
                        Datasheet
                      </a>
                    )}
                    {product.productSheet && (
                      <a href={product.productSheet} target="_blank" rel="noreferrer" onClick={() => trackProductDownload("Product Sheet")}>
                        Product Sheet
                      </a>
                    )}

                    {product.whitePaper && (
                      <a href={product.whitePaper} target="_blank" rel="noreferrer" onClick={() => trackProductDownload("White Paper")}>
                        White Paper
                      </a>
                    )}

                    {product.installationGuide && (
                      <a href={product.installationGuide} target="_blank" rel="noreferrer" onClick={() => trackProductDownload("Installation Guide")}>
                        Installation Guide
                      </a>
                    )}

                    {product.brochure && (
                      <a href={product.brochure} target="_blank" rel="noreferrer" onClick={() => trackProductDownload("Brochure")}>
                        Brochure
                      </a>
                    )}

                    {product.techNote && (
                      <a href={product.techNote} target="_blank" rel="noreferrer" onClick={() => trackProductDownload("Tech Note")}>
                        Tech Note
                      </a>
                    )}

                    {product.introVideo && (
                      <a href={product.introVideo} target="_blank" rel="noreferrer" onClick={() => trackProductDownload("Intro Video")}>
                        Intro Video
                      </a>
                    )}

                    {product.installationVideo && (
                      <a href={product.installationVideo} target="_blank" rel="noreferrer" onClick={() => trackProductDownload("Installation Video")}>
                        Installation Video
                      </a>
                    )}

                    {product.installationVideos && (
                      <a href={product.installationVideos} target="_blank" rel="noreferrer" onClick={() => trackProductDownload("Installation Videos")}>
                        Installation Videos
                      </a>
                    )}

                    {product.quickInstallationGuide && (
                      <a href={product.quickInstallationGuide} target="_blank" rel="noreferrer" onClick={() => trackProductDownload("Quick Installation Guide")}>
                        Quick Installation Guide
                      </a>
                    )}

                    {product.specialVideo1 && (
                      <a href={product.specialVideo1} target="_blank" rel="noreferrer" onClick={() => trackProductDownload(product.specialVideo1Title || "Special Video 1")}>
                        {product.specialVideo1Title}
                      </a>
                    )}

                    {product.specialVideo2 && (
                      <a href={product.specialVideo2} target="_blank" rel="noreferrer" onClick={() => trackProductDownload(product.specialVideo2Title || "Special Video 2")}>
                        {product.specialVideo2Title}
                      </a>
                    )}

                    

                    {/* 3D Models
                    {product.product === "PEACOC® Enhanced View and Access (EVA) High Density Patch Panel" && (
                      <a 
                        className="resource-link-3d"
                        onClick={() => setShow3D("eva")}
                      >
                        View in 3D Model
                      </a>
                    )}
                    

                    {product.product === "Small PEACOC® Multiport Mid-Span Terminal (MMT)" && (
                      <a 
                        className="resource-link-3d"
                        onClick={() => setShow3D("4PortMMT")}
                      >
                        View in 3D Model
                      </a>
                    )}
                     */}
                    <a
                        href={`/part-lookup?product=${encodeURIComponent(productSlug)}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        Configure Product
                      </a>
                    <a href="/support" target="_blank" rel="noreferrer">Contact Us</a>
                </div>
                </div>

              
                {product.featuredContentVideo && (
                  <>
              <center><h3>Featured Content</h3></center>
                <div className="video-wrapper">
                  <iframe
                    width="560"
                    height="315"
                    src={`https://www.youtube.com/embed/${videoId}`}
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </div>
                </>
                )}

{product.product?.includes("PEACOC® Enhanced View and Access") && (
  <div className="hotspot-wrapper">
    <img src={product.image} alt={product.product} className="hotspot-image" />

    <div className="hotspot" style={{ top: '60px', left: '30px' }}>
      <div className="tooltip">Easily identifiable ports<br/>numbered top and bottom</div>
    </div>
    <div className="hotspot" style={{ top: '50px', left: '110px' }}>
      <div className="tooltip">Multiple adapter types and configurations</div>
    </div>
    <div className="hotspot" style={{ top: '40px', left: '130px' }}>
      <div className="tooltip">High Density panels with up to 72 ports per 1RU</div>
    </div>
    <div className="hotspot" style={{ top: '100px', left: '140px' }}>
      <div className="tooltip">Patch and Splice cassettes</div>
    </div>

    <div className="hotspot" style={{ top: '40px', left: '180px' }}>
      <div className="tooltip">Easy Access with spreadable adapter technology</div>
    </div>
  </div>
)}

{product.product?.includes("PEACOC® Any Port Panel") && (
  <div className="hotspot-wrapper">
    <img src={product.image} alt={product.product} className="hotspot-image" />
    <div className="hotspot" style={{ top: '60px', left: '140px' }}>
      <div className="tooltip">Enhanced rear cable management</div>
    </div>
    <div className="hotspot" style={{ top: '70px', left: '100px' }}>
      <div className="tooltip">All front or front and rear access</div>
    </div>
    <div className="hotspot" style={{ top: '80px', left: '170px' }}>
      <div className="tooltip">Map Up to nine Base-16 transceivers per RU</div>
    </div>
    <div className="hotspot" style={{ top: '85px', left: '90px' }}>
      <div className="tooltip">Scales seamlessly to 400 Gb, 800 Gb, and 1.6T</div>
    </div>
    <div className="hotspot" style={{ top: '90px', left: '120px' }}>
      <div className="tooltip">Six cassette sizes supporting various applications</div>
    </div>
    <div className="hotspot" style={{ top: '100px', left: '75px' }}>
      <div className="tooltip">Mix and match various cassettes</div>
    </div>
    <div className="hotspot" style={{ top: '110px', left: '40px' }}>
      <div className="tooltip">Splice cassettes available</div>
    </div>
  </div>
)}

{product.product?.includes("PEACOC® 360 Spooling Patch Panel") && (
  <div className="hotspot-wrapper">
    <img src={product.image} alt={product.product} className="hotspot-image contain" />

    <div className="hotspot" style={{ top: '105px', left: '50px' }}>
      <div className="tooltip">96 fiber capacity</div>
    </div>
    <div className="hotspot" style={{ top: '110px', left: '110px' }}>
      <div className="tooltip">Featuring PEACOC spreadable adapter technology</div>
    </div>
    <div className="hotspot" style={{ top: '105px', left: '180px' }}>
      <div className="tooltip">SC or LC connector availability</div>
    </div>
  </div>
)}

{product.product?.includes("PEACOC® 360 Spooling Patch Panel") && (
  <div className="hotspot-wrapper" style={{ marginTop: -40}}>
    <img src={product.image7} alt={product.product} className="hotspot-image contain" />

    <div className="hotspot" style={{ top: '145px', left: '50px' }}>
      <div className="tooltip">Far end MPO, SC, or LC availability (spool)</div>
    </div>
    <div className="hotspot" style={{ top: '140px', left: '100px' }}>
      <div className="tooltip">100’ spool of cable</div>
    </div>
    <div className="hotspot" style={{ top: '100px', left: '130px' }}>
      <div className="tooltip">Ability to add additional cable spools</div>
    </div>
  </div>
)}




            </div>

            <div className="right-column">
                <h2>Product overview</h2>
                <p style={{ marginTop: 10}}>{formatCategoryDescription(product.text)}</p>
                <h3>{product.section1Heading}</h3>
                <p>{formatDescription(product.section1Description)}</p>
                
                {product.section2Heading && (
                  <>
                    <h3>{product.section2Heading}</h3>
                    <p>{formatDescription(product.section2Description)}</p>
                  </>
                )}

                {product.section3Description && (
                  <>
                    <h3>{product.section3Heading}</h3>
                    <p>{formatDescription(product.section3Description)}</p>
                  </>
                )}

                {/* {productImages.length === 1 && (
  <img src={productImages[2]} alt="Main Product" />
)} */}


{productImages.length > 1 && (
  <>
    <div className="article-slider-container">
      {productImages.length > gallerySlidesPerView && (
        <button
          type="button"
          className={`chevron chevron-left ${galleryIndex === 0 ? "disabled" : ""}`}
          onClick={prevImage}
          disabled={galleryIndex === 0}
          aria-label="Previous images"
        >
          &#10094;
        </button>
      )}

      <div className="article-slider-viewport">
        <div
          className="article-slider-track"
          style={{
            transform: `translateX(-${galleryIndex * (100 / gallerySlidesPerView)}%)`,
            "--gallery-slides-per-view": gallerySlidesPerView,
          }}
        >
          {productImages.map((imgUrl, idx) => (
            <div className="article-slider-slide" key={idx}>
              <div
                className="article-slider-card-product-page"
                onClick={() => setSelectedImage(imgUrl)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    setSelectedImage(imgUrl);
                  }
                }}
              >
                <div className="product-page-image-square-container">
                  <img src={imgUrl} alt={`Product image ${idx + 1}`} />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {productImages.length > gallerySlidesPerView && (
        <button
          type="button"
          className={`chevron chevron-right ${galleryIndex === galleryMaxIndex ? "disabled" : ""}`}
          onClick={nextImage}
          disabled={galleryIndex === galleryMaxIndex}
          aria-label="Next images"
        >
          &#10095;
        </button>
      )}
    </div>

    {selectedImage && (
      <div className="image-lightbox-overlay" onClick={() => setSelectedImage(null)}>
        <div className="image-lightbox-content" onClick={(e) => e.stopPropagation()}>
          <img src={selectedImage} alt="Preview" className="image-lightbox-img" />
        </div>
      </div>
    )}
  </>
)}


{productImages.length > 1 && (
  <div style={{ display: 'flex', justifyContent: 'center', marginTop: 10, flexWrap: 'wrap' }}>
    {productImages.map((_, idx) => (
      <div
        key={idx}
        onClick={() => setGalleryIndex(idx)}
        style={{
          width: 10,
          height: 10,
          borderRadius: '50%',
          backgroundColor: idx === galleryIndex ? '#2e7d32' : '#c5e1a5',
          margin: '0 4px',
          transition: 'background-color 0.3s',
          cursor: 'pointer'
        }}
      />
    ))}
  </div>
)}

<div className="product-accordion">
  {product.features?.length > 0 && (
    <div className="accordion-block">
      <button
        className="accordion-header"
        onClick={() => toggleSection("features")}
      >
        Features
        <span className="accordion-icon">
          {expandedSections.features ? "–" : "+"}
        </span>
      </button>
      {expandedSections.features && (
        <div className="accordion-body">
          {product.featuresHeading && (
            <h5 style={{ fontSize: 18, marginBottom: 10 }}>{product.featuresHeading}</h5>
          )}
          {Array.isArray(product.features) ? (
            <ul>
              {product.features.map((f, i) => <li key={i}>{f}</li>)}
            </ul>
          ) : (
            <p>{product.features}</p>
          )}

          {product.features2Heading && (
            <h5 style={{ fontSize: 18, marginBottom: 10 }}>{product.features2Heading}</h5>
          )}
          {Array.isArray(product.features2) ? (
            <ul>
              {product.features2.map((f, i) => <li key={i}>{f}</li>)}
            </ul>
          ) : (
            <p>{product.features2}</p>
          )}

          {product.features3Heading && (
            <h5 style={{ fontSize: 18, marginBottom: 10 }}>{product.features3Heading}</h5>
          )}
          {Array.isArray(product.features3) ? (
            <ul>
              {product.features3.map((f, i) => <li key={i}>{f}</li>)}
            </ul>
          ) : (
            <p>{product.features3}</p>
          )}
        </div>
      )}
    </div>
  )}

  {product.category1Heading && (
    <div className="accordion-block">
      <button
        className="accordion-header"
        onClick={() => toggleSection("category1")}
      >
        {product.category1Heading}
        <span className="accordion-icon">
          {expandedSections.category1 ? "–" : "+"}
        </span>
      </button>
      {expandedSections.category1 && (
        <div className="accordion-body">
          <div>{formatCategoryDescription(product.category1Description)}</div>
        </div>
      )}
    </div>
  )}

  {product.category2Heading && (
    <div className="accordion-block">
      <button
        className="accordion-header"
        onClick={() => toggleSection("category2")}
      >
        {product.category2Heading}
        <span className="accordion-icon">
          {expandedSections.category2 ? "–" : "+"}
        </span>
      </button>
      {expandedSections.category2 && (
        <div className="accordion-body">
          <div>{formatCategoryDescription(product.category2Description)}</div>
        </div>
      )}
    </div>
  )}

  {product.category3Heading && (
    <div className="accordion-block">
      <button
        className="accordion-header"
        onClick={() => toggleSection("category3")}
      >
        {product.category3Heading}
        <span className="accordion-icon">
          {expandedSections.category3 ? "–" : "+"}
        </span>
      </button>
      {expandedSections.category3 && (
        <div className="accordion-body">
          <div>{formatCategoryDescription(product.category3Description)}</div>
        </div>
      )}
    </div>
  )}

  {product.category4Heading && (
    <div className="accordion-block">
      <button
        className="accordion-header"
        onClick={() => toggleSection("category4")}
      >
        {product.category4Heading}
        <span className="accordion-icon">
          {expandedSections.category4 ? "–" : "+"}
        </span>
      </button>
      {expandedSections.category4 && (
        <div className="accordion-body">
          <div>{formatCategoryDescription(product.category4Description)}</div>
        </div>
      )}
    </div>
  )}

  {product.category5Heading && (
    <div className="accordion-block">
      <button
        className="accordion-header"
        onClick={() => toggleSection("category5")}
      >
        {product.category5Heading}
        <span className="accordion-icon">
          {expandedSections.category5 ? "–" : "+"}
        </span>
      </button>
      {expandedSections.category5 && (
        <div className="accordion-body">
          <div>{formatCategoryDescription(product.category5Description)}</div>
        </div>
      )}
    </div>
  )}

    {product.category6Heading && (
    <div className="accordion-block">
      <button
        className="accordion-header"
        onClick={() => toggleSection("category6")}
      >
        {product.category6Heading}
        <span className="accordion-icon">
          {expandedSections.category6 ? "–" : "+"}
        </span>
      </button>
      {expandedSections.category6 && (
        <div className="accordion-body">
          <div>{formatCategoryDescription(product.category6Description)}</div>
        </div>
      )}
    </div>
  )}

  {product.category7Heading && (
    <div className="accordion-block">
      <button
        className="accordion-header"
        onClick={() => toggleSection("category7")}
      >
        {product.category7Heading}
        <span className="accordion-icon">
          {expandedSections.category7 ? "–" : "+"}
        </span>
      </button>
      {expandedSections.category7 && (
        <div className="accordion-body">
          <div>{formatCategoryDescription(product.category7Description)}</div>
        </div>
      )}
    </div>
  )}

  {product.category8Heading && (
    <div className="accordion-block">
      <button
        className="accordion-header"
        onClick={() => toggleSection("category8")}
      >
        {product.category8Heading}
        <span className="accordion-icon">
          {expandedSections.category8 ? "–" : "+"}
        </span>
      </button>
      {expandedSections.category8 && (
        <div className="accordion-body">
          <div>{formatCategoryDescription(product.category8Description)}</div>
        </div>
      )}
    </div>
  )}

  {product.category9Heading && (
    <div className="accordion-block">
      <button
        className="accordion-header"
        onClick={() => toggleSection("category9")}
      >
        {product.category9Heading}
        <span className="accordion-icon">
          {expandedSections.category9 ? "–" : "+"}
        </span>
      </button>
      {expandedSections.category9 && (
        <div className="accordion-body">
          <div>{formatCategoryDescription(product.category9Description)}</div>
        </div>
      )}
    </div>
  )}

  {product.category10Heading && (
    <div className="accordion-block">
      <button
        className="accordion-header"
        onClick={() => toggleSection("category10")}
      >
        {product.category10Heading}
        <span className="accordion-icon">
          {expandedSections.category10 ? "–" : "+"}
        </span>
      </button>
      {expandedSections.category10 && (
        <div className="accordion-body">
          <div>{formatCategoryDescription(product.category10Description)}</div>
        </div>
      )}
    </div>
  )}

  {product.faq?.length > 0 && (
    <div className="accordion-block">
      <button
        className="accordion-header"
        onClick={() => toggleSection("faq")}
      >
        FAQs
        <span className="accordion-icon">
          {expandedSections.faq ? "–" : "+"}
        </span>
      </button>
      {expandedSections.faq && (
        <div className="accordion-body">
          {Array.isArray(product.faq) ? (
            product.faq.map((entry, idx) => {
              const [question, ...rest] = entry.split("?");
              const answer = rest.join("?").trim();

              return (
                <div key={idx} className="faq-item" style={{ marginBottom: ".5rem" }}>
                  <h5 style={{ marginBottom: "0.25rem", fontSize: 18 }}>{question}?</h5>
                  <p style={{ margin: 0 }}>{answer}</p>
                </div>
              );
            })
          ) : (
            <p>{product.faq}</p>
          )}
        </div>
      )}
    </div>
  )}
</div>




            </div>

        </div>

{frequentlyUsedWith.length > 0 && (
<div className="related-products-section">
  <center>
    <h2 className="related-title" style={{ marginBottom: 20 }}>Frequently used with</h2>
  </center>

  <div className="related-slider-wrapper">
    {frequentlyUsedWith.length > slidesPerView3 && (
      <button className="chevron chevron-left" onClick={handlePrev3}>
        &#10094;
      </button>
    )}

    <div className="related-slider-viewport">
      <div
        className={`related-slider-track ${
          frequentlyUsedWith.length < 3 ? "related-slider-track-centered" : ""
        }`}
        style={{
          transform: `translateX(-${currentIndex3 * (100 / slidesPerView3)}%)`,
          "--slides-per-view": slidesPerView3,
        }}
      >
        {frequentlyUsedWith.map((p, idx) => (
          <div
            className="related-slide"
            key={idx}
          >
            <div className="related-tile" onClick={() => navigate(`/${p.slug}`)}>
              <img
                src={p.image && p.image.trim() !== "" ? p.image : "https://placehold.co/150x150?text=No+Image"}
                alt={p.product}
                className="related-image"
              />

              <div className="related-content">
                <div
                  className="related-name"
                  dangerouslySetInnerHTML={{ __html: superscriptRegistered(p.product) }}
                />
                <div className="related-text">
                  {p.text?.length > 75 ? p.text.slice(0, 75) + "..." : p.text}
                </div>
              </div>

              <button className="cta-button">LEARN MORE</button>
            </div>
          </div>
        ))}
      </div>
    </div>

    {frequentlyUsedWith.length > slidesPerView3 && (
      <button className="chevron chevron-right" onClick={handleNext3}>
        &#10095;
      </button>
    )}
  </div>
</div>
)}

{relatedProducts.length > 0 && (
<div className="related-products-section">
  <center>
    <h2 className="related-title" style={{ marginBottom: 20 }}>Related products</h2>
  </center>

  <div className="related-slider-wrapper">
    {relatedProducts.length > slidesPerView && (
      <button className="chevron chevron-left" onClick={handlePrev2}>
        &#10094;
      </button>
    )}

    <div className="related-slider-viewport">
      <div
        className={`related-slider-track ${
          relatedProducts.length < 3 ? "related-slider-track-centered" : ""
        }`}
        style={{
          transform: `translateX(-${currentIndex2 * (100 / slidesPerView)}%)`,
          "--slides-per-view": slidesPerView,
        }}
      >
        {relatedProducts.map((p, idx) => (
          <div
            className="related-slide"
            key={idx}
          >
            <div className="related-tile" onClick={() => navigate(`/${p.slug}`)}>
              <img
                src={p.image && p.image.trim() !== "" ? p.image : "https://placehold.co/150x150?text=No+Image"}
                alt={p.product}
                className="related-image"
              />

              <div className="related-content">
                <div
                  className="related-name"
                  dangerouslySetInnerHTML={{ __html: superscriptRegistered(p.product) }}
                />
                <div className="related-text">
                  {p.text?.length > 75 ? p.text.slice(0, 75) + "..." : p.text}
                </div>
              </div>

              <button className="cta-button">LEARN MORE</button>
            </div>
          </div>
        ))}
      </div>
    </div>

    {relatedProducts.length > slidesPerView && (
      <button className="chevron chevron-right" onClick={handleNext2}>
        &#10095;
      </button>
    )}
  </div>
</div>
)}

{matchedSolutions.length > 0 && (
  <div className="solutions-power-section">
    <h2 className="solutions-power-title">Solutions we power</h2>

    <div className="solutions-power-grid">
      {matchedSolutions.map((sol, idx) => (
        <div
          key={idx}
          className="solution-card"
          onClick={() => navigate(`/solutions/${sol.slug}`)}
        >
          <img src={sol.solutionImage} alt={sol.name} className="solution-img" />

          <div className="solution-overlay">
            <h3>{sol.name}</h3>
            <button className="cta-button">LEARN MORE</button>
          </div>
        </div>
      ))}
    </div>
  </div>
)}

<div>
{/* 
{product.product?.includes("SELFOC® Microlens") && true && (
  <div className="lens-configurator-wrapper">
    
    <SelfocLensConfigurator
      onRequestQuote={(payload) => {
        console.log(payload);
        // open modal, route to contact page, or prefill form
      }}
    />
  </div>
)} */}

</div> 

{show3D && (
  <div className="viewer-overlay" onClick={() => setShow3D(false)}>
    <div className="viewer-modal" onClick={(e) => e.stopPropagation()}>
      
      <button className="viewer-close" onClick={() => setShow3D(false)}>
        ✕
      </button>

      <div className="viewer-toolbar">

  <button
    onClick={() =>
      setCameraPosition(new THREE.Vector3(0, 30, 95))
    }
  >
    Front
  </button>

  <button
    onClick={() =>
      setCameraPosition(new THREE.Vector3(95, 0, 0))
    }
  >
    Side
  </button>

  <button
    onClick={() =>
      setCameraPosition(new THREE.Vector3(0, 95, 0))
    }
  >
    Top
  </button>

  <button
    onClick={() =>
      setCameraPosition(new THREE.Vector3(65, 45, 65))
    }
  >
    Isometric
  </button>

  <button
    onClick={() =>
      setCameraPosition(new THREE.Vector3(0, 0, -95))
    }
  >
    Rear
  </button>

  {(show3D === "4PortMMT" || show3D === "4PortMMTOpen") && (
  <button
    onClick={() =>
      setShow3D(
        show3D === "4PortMMT"
          ? "4PortMMTOpen"
          : "4PortMMT"
      )
    }
  >
    {show3D === "4PortMMT"
      ? "See Inside"
      : "Show Cover"}
  </button>
)}

</div>

      <Canvas camera={{ position: [0, 0, 95], fov: 50 }}>
        <ambientLight intensity={2.5} />

        <directionalLight
          position={[10, 10, 10]}
          intensity={2}
        />

        <directionalLight
          position={[-10, 5, -10]}
          intensity={1.5}
        />

        <pointLight
          position={[0, 20, 20]}
          intensity={2}
        />

        <hemisphereLight
          skyColor={"#ffffff"}
          groundColor={"#444444"}
          intensity={1.5}
        />

        <CameraController targetPosition={cameraPosition} />

        <Model modelType={show3D} />

        <OrbitControls />
      </Canvas>

    </div>
  </div>
)}

        <div className="curved-footer" >
        <div className="curved-top-overlay"></div>
        
        <h2>Would you like to hear more?</h2>
        <p>Our experts would love to hear about your systems and how we can help</p>
        <a className="connect-button" href="/support">LET’S CONNECT</a>
        </div>



    </div>
  );
}

export default ProductPage;
